










































































import Vue from "vue";
import { mapState } from "vuex";
import Footer from "../components/master/Footer.vue";
import AbpBase from "../lib/abpbase";

export default AbpBase.extend({
  components: {
    Footer,
  },
  data() {
    return {
      forgotModel: {
        emailAddress: "",
      },
      submitted: false,
      rules: {
        emailAddress: [
          {
            required: true,
            message: "Please enter email address",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("session", ["user"]),
  },
  watch: {},
  methods: {
    async submitResetPassword() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      (this.$refs.forgotform as any).validate(async (valid: boolean) => {
        if (valid) {
          this.$Message.loading({
            content: "Sending request...",
            duration: 0,
          });
          let requestData = {
            emailAddress: this.forgotModel.emailAddress,
          };

          context.$store
            .dispatch("account/forgotPassword", requestData)
            .then((response) => {
              setTimeout(() => {
                context.$Message.destroy();
              }, 500);

              this.submitted = true;
            })
            .finally(() => {
              target.disabled = false;
            });
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
